/* @flow */
import React from 'react';

import Navigation from 'components/UIKit/Details/Navigation';
import NavItem from 'components/UIKit/Details/Navigation/NavItem';
import Count from 'components/UIKit/Details/Navigation/Count';
import TransactionIcon from 'components/icons/TransactionIcon';
import TreeIcon from 'components/icons/TreeIcon';
import DetailsIcon from 'components/icons/DetailsIcon';
import DownloadIcon from 'components/icons/DownloadIcon';
import { IconRegistry } from 'components/icons';

export default function DynamicEntityDetailsNavigation({
  details, active, handleOnClick, defs
}: any): React.Element {
  let item = (details || {}).item;
  let Icon = IconRegistry(item.type, defs);
  let type = <Icon style={{fontSize: '2rem'}} />;

  return (
    <Navigation details={details} type={type} active={active} handleOnClick={handleOnClick}>
      <NavItem spyId="actions" tooltip={{text: 'Actions'}}>
        <DownloadIcon />
      </NavItem>
      <NavItem spyId="details" tooltip={{text: 'Information'}}>
        <DetailsIcon />
      </NavItem>
      <NavItem spyId="hierarchy" tooltip={{text: 'Hierarchy'}}>
        <TreeIcon style={{color: '#888'}}/>
      </NavItem>
      <NavItem spyId="transactions" tooltip={{text: 'Transactions'}}>
        <TransactionIcon style={{color: '#888'}}/>
        <Count>{(item._transaction_logs || []).length}</Count>
      </NavItem>
    </Navigation>
  );
}
